import { gql } from '@apollo/client';
import { PAGE_SLOT_FIELDS, PAGE_VERSION_SUMMARIES_LIMIT } from './pageEditorGraphql';

export { PAGE_VERSION_SUMMARIES_LIMIT };

export const GET_PAGE_EDITOR = gql`
  query getPageEditor($id: ID!, $widgetId: String) {
    page (id: $id) {
      _id
      _creator
      title
      path
      canonicalRel
      publishedVersion
      is_root
      category {
        _id
        title
        path
      }
      template {
        templateId
        version
        props
      }
      slots {
        ${PAGE_SLOT_FIELDS}
      }
      metadata
      updatedAt
      updatedBy
      createdAt
      canUserRevert
      canUserRequestApproval
      state
      commitedVersion
    }
    templates {
      id
      templateSettings
    }
    widgetPresets(widgetId:$widgetId) {
      widgetId
      title
      _id
      createdAt
      updatedAt
      createdBy
      updatedBy
      props
    }
  }
`;

export const PAGE_VERSION_SUMMARIES = gql`
  query pageVersionSummaries($pageId: ID!, $limit: Int, $offset: Int) {
    pageVersionSummaries(pageId: $pageId, limit: $limit, offset: $offset) {
      _id
      versionId
      updatedAt
      updatedBy
      notes
    }
  }
`;

export const PAGE_VERSION = gql`
  query pageVersion($pageId: ID!, $versionId: String!) {
    pageVersion(pageId: $pageId, versionId: $versionId) {
      versionId
      template {
        templateId
        version
        props
      }
      slots {
        ${PAGE_SLOT_FIELDS}
      }
    }
  }
`;

export function patchPageEditorAfterSave(cache, pageId, updatePageResult) {
  cache.updateQuery(
    { query: GET_PAGE_EDITOR, variables: { id: pageId } },
    (data) => {
      if (!data?.page || !updatePageResult) return data;

      const nextPage = { ...data.page };

      if (updatePageResult.updatedAt != null) {
        nextPage.updatedAt = updatePageResult.updatedAt;
      }
      if (updatePageResult.slots) {
        nextPage.slots = updatePageResult.slots;
      }
      if (updatePageResult.metadata) {
        nextPage.metadata = updatePageResult.metadata;
      }
      if (updatePageResult.title != null) {
        nextPage.title = updatePageResult.title;
      }
      if (updatePageResult.template) {
        nextPage.template = updatePageResult.template;
      }
      if (updatePageResult.category) {
        nextPage.category = { ...nextPage.category, ...updatePageResult.category };
      }

      return { ...data, page: nextPage };
    }
  );
}

export function prependVersionSummary(cache, pageId, newVersion, limit) {
  cache.updateQuery(
    {
      query: PAGE_VERSION_SUMMARIES,
      variables: { pageId, limit, offset: 0 },
    },
    (data) => {
      const existing = data?.pageVersionSummaries || [];
      const alreadyPresent = existing.some(v => v.versionId === newVersion.versionId);
      if (alreadyPresent) return data;
      return {
        ...data,
        pageVersionSummaries: [newVersion, ...existing],
      };
    }
  );
}
